import React from 'react';
import InfoButton from '../../InfoButton';

import SwitchButton from './SwitchButton';

import styles from './toggleSwitch.scss';

const TitleSwitch = (props) => {
    const { id, value, label, hiddenLabel, description, formGroupCssClass, hoverText, disabled, disableLabelSelect, 'data-testid': dataTestId, ...rest } = props;

    const inputProps = {
        ...rest,
        id,
        checked: value || false,
        disabled,
    };

    return (
        <div className={`form-group ${description && 'description'} ${styles.toggleSwitch} ${formGroupCssClass}`} data-testid={dataTestId || undefined}>
            <div className="label-wrapper">
                <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                    {label}
                    {hoverText && <InfoButton hoverText={hoverText} />}
                </label>
                {description && (<small>{description}</small>)}
            </div>
            <div className="input-wrapper">
                <SwitchButton {...inputProps} data-testid={dataTestId && `${dataTestId}.toggle`} />
            </div>
        </div>
    );
};

export default TitleSwitch;
